import { ActivityTimelinePlayground } from "../ActivityTimelinePlayground";
import { BoardPlayground } from "../boardPlayground/BoardPlayground";
import { CalendarHeatmapPlayground } from "../CalendarHeatmapPlayground";
import { DensityChartPlayground } from "../DensityChartPlayground";
import { DescriptionListPlayground } from "../DescriptionListPlayground";
import { MemoSectionPlayground } from "../MemoSectionPlayground";
import { SummaryStatsPlayground } from "../SummaryStatsPlayground";
import type { PlaygroundComponentEntry } from "../playgroundComponents";

export const dataDisplayEntries: PlaygroundComponentEntry[] = [
    {
        id: "description-list",
        label: "Description list",
        description: "Label/value pairs for record details.",
        group: "components",
        render: () => <DescriptionListPlayground />,
    },
    {
        id: "memo-section",
        label: "Memo section",
        description: "Titled memo block.",
        group: "components",
        render: () => <MemoSectionPlayground />,
    },
    {
        id: "summary-stats",
        label: "Summary stats",
        description: "Row of headline metrics.",
        group: "components",
        render: () => <SummaryStatsPlayground />,
    },
    {
        id: "activity-timeline",
        label: "Activity timeline",
        description: "Chronological activity feed.",
        group: "components",
        render: () => <ActivityTimelinePlayground />,
    },
    {
        id: "calendar-heatmap",
        label: "Calendar heatmap",
        description: "Daily intensity grid for a date range.",
        group: "components",
        render: () => <CalendarHeatmapPlayground />,
    },
    {
        id: "density-chart",
        label: "Density chart",
        description:
            "Stacked daily or weekly bars with a draggable window, a period tooltip and a slice tooltip with consumer rows.",
        group: "components",
        render: () => <DensityChartPlayground />,
    },
    {
        id: "board",
        label: "Board",
        description:
            "Kanban columns of cards; the surface filters and renders the cards.",
        group: "ready-components",
        layout: "fill",
        render: () => <BoardPlayground />,
    },
];
